import RestService from "../../services/rest.service"

export const getWorkflowList = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/admin/workflow/`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const postCheckUsedCode = (code) => (dispatch) => {
  let body = { code: code }
  return new Promise((resolve, reject) => {
    RestService.post(`app/admin/workflow/code/check`, body).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const getWorkflowTemplate = (type) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/admin/workflow/template/${type}`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const postSearch = (type, word) => (dispatch) => {
  let data = {
    word
  }
  return new Promise((resolve, reject) => {
    RestService.post(`app/admin/workflow/search/${type}`, data).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const postCreateWorkflow = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/admin/workflow`, data).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const deleteWorkflow = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.delete(`app/admin/workflow/${id}`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const getWorkflow = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/admin/workflow/${id}`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const postWorkflowStep = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/admin/workflow/step`, data).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}


export const putWorkflowStep = (id, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.put(`app/admin/workflow/step/${id}`, data).then(
      () => {
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const deleteWorkflowStep = (id, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.delete(`app/admin/workflow/step/${id}`, data).then(
      () => {
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const putWorkflow = (id, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.put(`app/admin/workflow/${id}`, data).then(
      () => {
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const getWorkflowStep = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/admin/workflow/step/${id}`).then(
      (response) => {
        let data = response?.data?.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const putWorkflowSection = (id, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.put(`app/admin/workflow/section/${id}`, data).then(
      () => {
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}